import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import { currency, equalOrThreeDashes, percentage, stringToDate } from 'utils';

const BruttoProductionTableRow = ({ production }) => {
	// prodBp and prodJp default values, in case there's no data
	const {
		surname,
		businessName,
		policyNo,
		firstname,
		dateCreated: importDateKCL,
		reportedDate: importDateBrutto,
		prodBp = 0,
		prodJp = 0,
		businessShare,
		bruttoId,
	} = production;

	const businessOrFullnameOrThreeDashes = (firstname, surname, businessName) => {
		if (businessName) {
			return businessName;
		} else if (surname && firstname) {
			return `${surname} ${firstname}`;
		} else {
			return equalOrThreeDashes();
		}
	};

	return (
		<TableRow key={bruttoId}>
			<TableCell>{equalOrThreeDashes(policyNo)}</TableCell>
			<TableCell>{businessOrFullnameOrThreeDashes(firstname, surname, businessName)}</TableCell>
			<TableCell>
				<div>{equalOrThreeDashes(stringToDate(importDateKCL))}</div>
				<div>{equalOrThreeDashes(stringToDate(importDateBrutto))}</div>
			</TableCell>
			<TableCell>
				<div>{currency(prodBp)}</div>
				<div>{currency(prodJp)}</div>
			</TableCell>
			<TableCell>{percentage(businessShare)}</TableCell>
		</TableRow>
	);
};

BruttoProductionTableRow.propTypes = {
	production: PropTypes.shape({
		bruttoId: PropTypes.number,
		businessName: PropTypes.string,
		prodBp: PropTypes.number,
		businessShare: PropTypes.number,
		firstname: PropTypes.string,
		surname: PropTypes.string,
		policyNo: PropTypes.number,
		reportedDate: PropTypes.string,
		dateCreated: PropTypes.string,
		prodJp: PropTypes.number,
	}),
};

export default BruttoProductionTableRow;
